<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ExtraChargeClause')"
    width="604px"
    :close-on-click-modal="false"
    class="app-main-inner"
    :append-to-body="appendToBody"
  >
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="finalRowData"
      style="width:100%;height:300px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <span slot="footer" :style="appendToBody ? 'width: 100%;display: inline-block;' : 'padding:10px;'">
      <div style="float:left">
        <el-button :disabled="disabled" type="primary" @click="add">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
        <el-button :disabled="disabled" type="danger" @click="remove">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
      </div>
      <div style="float:right">
        <el-button :disabled="disabled" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import lang from '@/lang'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { SurchargeTerms } from '@/class/model/booking/SurchargeTerms'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import ColumnUtils from '@/utils/ColumnUtils'
import { chargeItemCompatibleLanguage } from '@/utils/commonUtil'

export default {
  name: 'SelectSurchargeTermsDialog',
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, default: '' },
    rowData: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    appendToBody: { type: Boolean, default: false }
  },
  data() {
    const chargeItemSet = new Set(chargeItemCompatibleLanguage())
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        rowHeight: 32,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.chargeItem'),
          field: 'chargeItemId',
          width: 150,
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...chargeItemSet],
              methodParams: { active: true },
              tagValue: 'itemId',
              tagName: 'zhName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global'
            }
          },
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('SeaExport.ExtraChargeClause'),
          field: 'terms',
          width: 350,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'cargo-advance-select',
            selectType: TYPE_NAMES.basic_data_PaymentTerm,
            tagValue: 'code',
            tagName: 'name',
            attrs: {
              style: 'display: flex;flex-direction: column;align-items: normal;'
            }
          }
        }
      ],
      editRowData: [],
      gridApi: null,
      chargeItemSet
    }
  },
  computed: {
    finalRowData() {
      return this.editRowData.filter(p => !p.deleted)
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.gridApi.deselectAll()
      }
    },
    rowData(newVal) {
      this.editRowData = []
      for (const item of newVal) {
        this.editRowData.push({ ...item })
      }
    }
  },
  methods: {
    add() {
      const row = new SurchargeTerms().fillDefaultValue().getData()
      row.jobUuid = this.jobUuid
      this.editRowData.push(row)
      this.$nextTick(() => {
        this.gridApi.clearFocusedCell()
        this.gridApi.setFocusedCell(this.finalRowData.length - 1, this.gridApi.columnController.getAllDisplayedColumns()[0])
      })
    },
    remove() {
      const cell = this.gridApi.getFocusedCell()
      if (!cell) {
        return
      }
      const row = this.finalRowData[cell.rowIndex]
      if (!row) {
        return
      }
      if (row.uuid) {
        row.deleted = true
        /* 强制刷新finalRowData */
        const tempRowData = this.editRowData
        this.editRowData = []
        this.$nextTick(() => {
          this.editRowData = tempRowData
        })
      } else {
        const index = this.editRowData.findIndex(p => p === row)
        if (index > -1) {
          this.editRowData.splice(index, 1)
        }
      }
    },
    save() {
      for (let i = 0; i < this.editRowData.length; ++i) {
        const item = this.editRowData[i]
        if (!item.chargeItemId) {
          this.$message.warning(lang.t('Message.PleaseInputCosts'))
          this.gridApi.setFocusedCell(i, this.gridApi.columnController.getAllDisplayedColumns()[0])
          return
        }
        if (!item.terms) {
          this.$message.warning(lang.t('Message.SelectTheSurchargeClause'))
          this.gridApi.setFocusedCell(i, this.gridApi.columnController.getAllDisplayedColumns()[0])
          return
        }
      }
      this.$emit('callback', this.editRowData)
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
